import SoftButton from "components/SoftButton";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

export const RecoverFlowDialog = ({ open, onAccept, onClose, flow }) => {
   return (
      <Dialog open={open} onClose={onClose} fullWidth>
         <DialogTitle>Recover Flow</DialogTitle>
         <DialogContent>
            Do you want to recover this <strong>{flow.name}</strong>?
         </DialogContent>
         <DialogActions>
            <SoftButton onClick={onClose} color="primary" variant="outlined">
               Close
            </SoftButton>
            <SoftButton color="info" onClick={onAccept}>
               Recover
            </SoftButton>
         </DialogActions>
      </Dialog>
   );
};
